import {Injectable} from '@angular/core';
import {ConnectionHttpService, ApiResourceLocation, RequestEvent} from '@softline/core';
import {NewTicketDocument} from '../data/document.model';
import {Observable} from 'rxjs';
import {SOFTLINE_API_TICKET_DOCUMENT} from '../ticket.api';

@Injectable()
export class UploadTicketDocumentService {
  constructor(private service: ConnectionHttpService) {}

  uploadDocument(document: NewTicketDocument): Observable<RequestEvent<any>> {
    const location: ApiResourceLocation = { path: SOFTLINE_API_TICKET_DOCUMENT };
    return this.service.upload(location, document);
  }
}
